/**
 * Resolve location tag ids to display names (#999).
 */

import type { LocationTag } from '../types/locationTag';

export function buildLocationTagNameById(
  tags: readonly Pick<LocationTag, 'id' | 'name'>[],
): ReadonlyMap<number, string> {
  const map = new Map<number, string>();
  for (const tag of tags) {
    if (tag.id != null) {
      map.set(tag.id, tag.name);
    }
  }
  return map;
}

export function resolveLocationTagName(
  locationTagId: number | null | undefined,
  nameById: ReadonlyMap<number, string>,
): string | null {
  if (locationTagId == null) {
    return null;
  }
  const name = nameById.get(locationTagId)?.trim();
  return name || null;
}
